import type { TemplateAssignedOffer } from '@core/workflow-templates-types';

export enum EntityStoreKey {
  EmailTemplatesGeneral = 'emailTemplatesGeneral',
  EmailTemplatesAutoReplyCollection = 'emailTemplatesAutoReplyCollection',
  EmailTemplatesAutoReplyItem = 'emailTemplatesAutoReplyItem',
  EmailTemplatesEventInvitation = 'emailTemplatesEventInvitation',
  EmailTemplatesAssignedOffers = 'emailTemplatesAssignedOffers',
  EmailTemplatesAssignedJobTemplates = 'emailTemplatesAssignedJobTemplates',
}

export type EventInvitationCollectionPayload = { includeLastUsed: 'candidate' | 'interviewer' };

export type EmailTemplatesAssignedOffersList = {
  assignedOffers: TemplateAssignedOffer[];
  meta: { limit: number; page: number; totalCount: number };
};

export type EmailTemplatesAssignedJobTemplatesList = {
  assignedOfferTemplates: TemplateAssignedOffer[];
  meta: { limit: number; page: number; totalCount: number };
};
